import { ItemList } from '../orm'

class CoursePackageOptionsList extends ItemList {
  getEntityKey() {
    return 'course_package_options/get_dropdown_options'
  }
}

export const coursePackageOptionsList = new CoursePackageOptionsList('course_package_options__default')
